import React from 'react'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Kanban from './Compoents/KbBoard';
import Home from './Compoents/Home';


const App = () => {
  return (
    <>

    <Router>
      <Routes>
        <Route path='/Kanban' element={<Kanban/>}/>
        <Route path='/' element={<Home/>}/>
      </Routes>
    </Router>

    </>
  )
}

export default App